import type {
  ChangeEmailDataToBackend,
  ConfirmDataToBackend,
  ConfirmErrors,
  ResendCodeDataToBackend,
  SendCodeErrors,
  SendCodeFromBackend,
} from './types';

import { URL } from '../../../constants';
import { httpApiService } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';
import { emailConfirmErrorHandler, sendCodeErrorHandler } from './error-adapter';

// ---

export const sendCode = (
  requestData: ChangeEmailDataToBackend,
) => {
  type AdapterProps = { request: typeof requestData; response: SendCodeFromBackend };

  return defaultRequestService<AdapterProps, void, SendCodeErrors | null>(
    URL.EMAIL_SEND_CODE,
    httpApiService.post,
    {
      requestData,
      errorHandler: sendCodeErrorHandler,
    },
  );
};

export const resendCode = (requestData: ResendCodeDataToBackend) => {
  type AdapterProps = { request: typeof requestData; response: SendCodeFromBackend };

  return defaultRequestService<AdapterProps>(
    URL.EMAIL_RESEND_CODE,
    httpApiService.post,
    { requestData },
  );
};

export const emailConfirm = (
  requestData: ConfirmDataToBackend,
) => {
  type AdapterProps = { request: typeof requestData };

  return defaultRequestService<AdapterProps, void, ConfirmErrors | null>(
    URL.EMAIL_CONFIRM,
    httpApiService.patch,
    {
      requestData,
      errorHandler: emailConfirmErrorHandler,
    },
  );
};
